import { Users, Handshake } from 'lucide-react';
import Reveal from './Reveal';

const ways = [
  {
    icon: Users,
    who: 'To your own buyers',
    head: 'Send a menu to named buyers, see which listings they opened, and follow up while it’s warm.',
    points: [
      'One place for your book, priced and current.',
      'A short morning list of who to reach out to.',
      'A link you can switch off anytime.',
    ],
  },
  {
    icon: Handshake,
    who: 'Through your brokers',
    head: 'Share listings with the brokers you work with. They sell from their menus; you decide what each one sees.',
    points: [
      'Choose which broker sees which listing.',
      'When a broker resells your listing, buyers see the broker as the supplier, never you.',
      'Broker not on Cannafax yet? Invite them.',
    ],
  },
];

const BothSides = () => (
  <section id="both" className="scroll-mt-16 border-b border-border bg-subtle py-20 md:py-24">
    <div className="container-wide">
      <Reveal className="max-w-2xl">
        <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">
          One menu, two ways to sell
        </h2>
        <p className="mt-4 text-lg text-muted-foreground">
          Sell to the buyers you already have, and put your listings in front of the brokers you
          work with, from the same place.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {ways.map((s, i) => (
          <Reveal key={s.who} delay={i * 100}>
            <div className="h-full rounded-xl border border-border bg-card p-7">
              <s.icon className="h-6 w-6 text-brand" aria-hidden="true" />
              <p className="mt-5 text-xs font-medium uppercase tracking-wide text-muted-foreground">
                {s.who}
              </p>
              <p className="mt-2 text-xl font-medium leading-snug">{s.head}</p>
              <ul className="mt-5 space-y-3">
                {s.points.map((p) => (
                  <li key={p} className="flex gap-3 text-sm text-muted-foreground">
                    <span className="mt-2 circle-1.5 shrink-0 bg-brand" />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default BothSides;
